export var ControlValuesLevelEnum;
(function (ControlValuesLevelEnum) {
    ControlValuesLevelEnum["WORKFLOW_CONTROLS"] = "workflow";
    ControlValuesLevelEnum["STEP_CONTROLS"] = "step";
    ControlValuesLevelEnum["LAYOUT_CONTROLS"] = "layout";
    ControlValuesLevelEnum["STEP_PROVIDER_CONTROLS"] = "step_provider";
    ControlValuesLevelEnum["STEP_INTEGRATION_CONTROLS"] = "step_integration";
})(ControlValuesLevelEnum || (ControlValuesLevelEnum = {}));
//# sourceMappingURL=controls.js.map